import moment from 'moment'

export const sanitizeTicketCode = ticketCode => String(ticketCode || '').trim()

export const isTicketVerificationValid = ticket => {
  if (!ticket?.verification?.available) {
    return true
  }

  if (!ticket.verified) {
    return false
  }

  if (!ticket.verifiedUntil) {
    return true
  }

  return moment(ticket.verifiedUntil, 'DD.MM.YYYY HH:mm', true).isAfter(moment())
}
